export default {
  translate(str, lang) {
    if (lang == 'EN') {
      return str
    }

    if (lang == 'BG') {
      return this.translateBG(str)
    }

    return str
  },

  translateBG(str) {
    switch (str) {
      case 'Password':
        return 'Парола'
      case 'Sign in':
        return 'Вписване'
      case 'Sign up':
        return 'Регистрация'
      case 'Your email':
        return 'Вашият email'
      case 'Business e-mail':
        return 'Бизнес e-mail';
      case 'Your password':
        return 'Вашата парола'
      case 'Login':
        return 'Вписване'
      case 'Always Free Account':
        return 'Винаги Безплатен Акаунт'
      case 'Create Always Free Account':
        return 'Създаване на Винаги Безплатен Акаунт'
      case 'Contact':
        return 'Контакт'
      case 'Comming soon':
        return 'Очаквайте скоро'
      case 'Successfully signed out':
        return 'Успешен изход.'
      case 'Thank you for your interest in a always free account of MRP One.':
        return 'Благodарим ви за интереса към винаги безплатен акаунт на MRP One.'
      case 'Please fill out the form below so we can better understand your needs.':
        return 'Моля, попълнете формуляра по-долу, за да разберем по-добре нуждите ви.'
      case 'Your company name':
        return 'Вашата фирма'
      case 'Your name':
        return 'Вашето име'
      case 'Your position':
        return 'Вашата позиция'
      case 'Count of employees':
        return 'Брой работници'
      case 'Additional details':
        return 'Допълнителни детайли'
      case 'Send':
        return 'Изпрати'
      case 'Go back to www.prodexis.com':
        return 'Към www.prodexis.com'
      case 'Try it free':
        return 'Пробвайте безплатно'
      case 'No payment info needed':
        return 'Без информация за плащане'
      case 'No commitment required':
        return 'Без ангажимент'
      case 'Easy setup':
        return 'Лесна настройка'
      case 'You are signing up with the Always Free Tier':
        return 'Регистрирате се с винаги безплатния абонамент (Always Free Tier)'
      case 'Fill in the fields, breeze through a quick wizard, and you are ready in under 3 minutes.':
        return 'Попълнете полетата, преминете през бързия уизард и сте готови за под 3 минути.'
      case 'Confirm password':
        return 'Потвърди паролата'
      case 'Passwords do not match':
        return 'Паролите не съвпадат'
      case 'Password must be at least 8 characters':
        return 'Паролата трябва да е поне 8 символа'
      case 'Company domain':
        return 'Домейн на фирмата'
      case 'Email already registered':
        return 'Този имейл вече е регистриран'
      case 'Welcome! Your account has been created.':
        return 'Добре дошли! Вашият акаунт беше създаден.'
      case 'Please verify your email. Check your inbox.':
        return 'Моля, потвърдете вашия имейл. Проверете пощенската си кутия.'
      case 'Resend':
        return 'Изпрати отново'
      case 'Verification email sent':
        return 'Изпратен е имейл за потвърждение'
      case 'Please wait before requesting another verification email.':
        return 'Моля, изчакайте преди да заявите нов имейл за потвърждение.'
      case 'Email verified!':
        return 'Имейлът е потвърден!'
      case 'You can now use all features.':
        return 'Вече имате достъп до всички функции.'
      case 'Go to app':
        return 'Към приложението'
      case 'Verification link is invalid or has expired.':
        return 'Линкът за потвърждение е невалиден или е изтекъл.'
      case 'Resend verification':
        return 'Изпрати потвърждение отново'
      case 'Verifying your email...':
        return 'Потвърждаване на имейла...'
      case 'Missing verification parameters.':
        return 'Липсват параметри за потвърждение.'
      case 'The verification link could not be validated.':
        return 'Линкът за потвърждение не можа да бъде валидиран.'
      case 'Subscription Tier':
        return 'Абонамент'
      case 'Free Tier':
        return 'Безплатен'
      case 'Starter Tier':
        return 'Стартов'
      case 'Growth Tier':
        return 'Растеж'
      case 'Enterprise Tier':
        return 'Корпоративен'
      case 'Plan & Billing':
        return 'План и Плащане'
      case 'Email verification':
        return 'Потвърждение на имейл'
      case 'Email Verified':
        return 'Имейлът е потвърден'
      case 'Your email address has not been verified yet.':
        return 'Вашият имейл адрес все още не е потвърден.'
      case 'Resend Verification Email':
        return 'Изпрати отново имейл за потвърждение'
      case 'Current Plan':
        return 'Текущ план'
      case 'You are on the Free Tier. Upgrade anytime to unlock more features.':
        return 'Използвате безплатния план. Надградете по всяко време за повече функции.'
      case 'Coming soon':
        return 'Скоро'
      case 'Upgrade':
        return 'Надграждане'
      case 'Upgrade options coming soon.':
        return 'Опциите за надграждане предстоят.'
      case 'Verification email sent. Please check your inbox.':
        return 'Имейлът за потвърждение е изпратен. Проверете пощата си.'
      case 'Please verify your email address':
        return 'Моля, потвърдете имейл адреса си'
      default:
        return str
    }
  },
}
